import { shallowRef, type ShallowRef } from "vue";

export type MarketGroupConfigurationSaveFn = () => Promise<void>;

export const marketGroupConfigurationSaveRef: ShallowRef<MarketGroupConfigurationSaveFn | null> =
  shallowRef(null);
